module.exports = __webpack_public_path__ + "static/media/trailofbits-dark-mode.c6848735.png";